import { render, staticRenderFns } from "./BackofficeProcedimentosInternacao.vue?vue&type=template&id=5206e890"
import script from "./BackofficeProcedimentosInternacao.vue?vue&type=script&lang=ts"
export * from "./BackofficeProcedimentosInternacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports